import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/dist/css/splide.min.css';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

document.addEventListener("DOMContentLoaded", () => {
    // フェードイン + 下からスライド
    gsap.from(".js-fadeup", {
        opacity: 0,
        y: 30,
        duration: 1,
        ease: "power2.out",
    });
    // スクロールで出現（ScrollTrigger）
    gsap.from(".js-scroll-fadeup", {
        scrollTrigger: {
            trigger: ".js-scroll-fadeup",
            start: "top 80%", // 要素の上端がビューポートの80%に達したら発火
            toggleActions: "play none none none",
        },
        opacity: 0,
        y: 40,
        duration: 0.8,
        ease: "power2.out",
    });
});

// overlay-script.js
document.addEventListener('DOMContentLoaded', () => {
  const hamburger = document.querySelector('.hamburger-overlay');
  const nav = document.querySelector('.nav-overlay');

  hamburger.addEventListener('click', () => {
    hamburger.classList.toggle('active');
    nav.classList.toggle('active');

    const isOpen = hamburger.classList.contains('active');
    hamburger.setAttribute('aria-expanded', isOpen);
    nav.setAttribute('aria-hidden', !isOpen);

    // メニューオープン時に背景スクロールを防止
    document.body.style.overflow = isOpen ? 'hidden' : '';
  });

  // ESCキーでメニューを閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && nav.classList.contains('active')) {
      hamburger.classList.remove('active');
      nav.classList.remove('active');
      hamburger.setAttribute('aria-expanded', false);
      nav.setAttribute('aria-hidden', true);
      document.body.style.overflow = '';
    }
  });
});

// splide - FV
document.addEventListener('DOMContentLoaded', function() {
    const fvSplide = document.querySelector('.p-top-fv__slide .splide');
    if (fvSplide) {
        const splide = new Splide(fvSplide, {
            type: 'fade',
            perPage: 1,
            autoplay: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            interval: 3000,
            speed: 1500,
            pagination: false,
            arrows: false,
            rewind: true
        });
        splide.mount();
    }
});

// splide - Gallery (PC/SP responsive)
document.addEventListener('DOMContentLoaded', function() {
    const gallerySplide = document.querySelector('#gallery-splide');
    if (!gallerySplide) return;

    const splide = new Splide('#gallery-splide', {
        type: 'loop',
        fixedWidth: '450px',
        autoScroll: {
            speed: 1,
            pauseOnHover: false,
            pauseOnFocus: false
        },
        pagination: false,
        arrows: false,
        gap: '4vw',
        drag: false,
        breakpoints: {
            767: {
                fixedWidth: null,
                perPage: 1,
                autoScroll: false,
                autoplay: false,
                interval: 3000,
                speed: 800,
                pagination: true,
                gap: '5vw',
                drag: true
            }
        }
    });

    splide.mount({ AutoScroll });

    setTimeout(() => {
        gallerySplide.classList.add('is-active');
    }, 100);
});